import { render } from "./ViewBar.vue?vue&type=template&id=88382a28"
import script from "./ViewBar.vue?vue&type=script&lang=js"
export * from "./ViewBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__